import Vue from 'vue'
import VueRouter from 'vue-router'
import TopPage from '@/views/TopPage.vue'
import StreamViewerQs from '@/views/StreamViewerQs.vue'
// import Profile from '@/views/Profile.vue'
// import StreamViewer from '@/views/StreamViewer.vue'
import StreamViewerP1 from '@/views/StreamViewerP1.vue'
import StreamViewerP2 from '@/views/StreamViewerP2.vue'
import StreamViewerP3 from '@/views/StreamViewerP3.vue'
import K01_01 from '@/views/K01-01.vue'
import K02_01 from '@/views/K02-01.vue'
import K03_01 from '@/views/K03-01.vue'
import K03_02 from '@/views/K03-02.vue'
import K04_01 from '@/views/K04-01.vue'
import K05_01 from '@/views/K05-01.vue'
import K05_02 from '@/views/K05-02.vue'
import K05_03 from '@/views/K05-03.vue'
import K06_01 from '@/views/K06-01.vue'
import K06_02 from '@/views/K06-02.vue'
import K06_03 from '@/views/K06-03.vue'
import K06_04 from '@/views/K06-04.vue'
import K06_05 from '@/views/K06-05.vue'
import K07_01 from '@/views/K07-01.vue'
import K07_02 from '@/views/K07-02.vue'
import K07_03 from '@/views/K07-03.vue'
import K07_04 from '@/views/K07-04.vue'
import K07_05 from '@/views/K07-05.vue'
import K08_01 from '@/views/K08-01.vue'
import K08_02 from '@/views/K08-02.vue'
import K08_03 from '@/views/K08-03.vue'
import K08_04 from '@/views/K08-04.vue'
import K08_05 from '@/views/K08-05.vue'
import F01_01 from '@/views/F01-01.vue'
import F01_02 from '@/views/F01-02.vue'
import F01_03 from '@/views/F01-03.vue'
import F01_04 from '@/views/F01-04.vue'
import F01_05 from '@/views/F01-05.vue'
import F02_01 from '@/views/F02-01.vue'
import F02_02 from '@/views/F02-02.vue'
import F02_03 from '@/views/F02-03.vue'
import F02_04 from '@/views/F02-04.vue'
import F02_05 from '@/views/F02-05.vue'
import F02_06 from '@/views/F02-06.vue'
import F02_07 from '@/views/F02-07.vue'
import F03_01 from '@/views/F03-01.vue'
import F03_02 from '@/views/F03-02.vue'
import F04_01 from '@/views/F04-01.vue'
import F04_02 from '@/views/F04-02.vue'
import F04_03 from '@/views/F04-03.vue'
import F04_04 from '@/views/F04-04.vue'
import F04_05 from '@/views/F04-05.vue'
import F04_06 from '@/views/F04-06.vue'
import F04_07 from '@/views/F04-07.vue'
import F04_08 from '@/views/F04-08.vue'
import F04_09 from '@/views/F04-09.vue'
import F04_10 from '@/views/F04-10.vue'
import F04_11 from '@/views/F04-11.vue'
import F04_12 from '@/views/F04-12.vue'
import F04_13 from '@/views/F04-13.vue'
import F05_01 from '@/views/F05-01.vue'
import F05_02 from '@/views/F05-02.vue'
import F05_03 from '@/views/F05-03.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'TopPage',
    component: TopPage,
    meta: {
      onMenu: false, // [MiiaFW] メニュー表示用の拡張
      requiresAuth: false // [MiiaFW] 認証必須フラグ
    }
  },
  {
    path: '/stream_viewer_qs',
    name: 'オンデマンドストリーム配信(Query String)',
    component: StreamViewerQs,
    meta: {
      onMenu: true, // [MiiaFW] メニュー表示用の拡張
      requiresAuth: false // [MiiaFW] 認証必須フラグ
    }
  },
  // {
  //   path: '/stream_viewer',
  //   name: 'オンデマンドストリーム配信',
  //   component: StreamViewer,
  //   meta: {
  //     onMenu: true, // [MiiaFW] メニュー表示用の拡張
  //     requiresAuth: false // [MiiaFW] 認証必須フラグ
  //   }
  // }
  {
    path: '/stream_viewer_p1',
    name: 'ページ1',
    component: StreamViewerP1,
    meta: {
      onMenu: true, // [MiiaFW] メニュー表示用の拡張
      requiresAuth: false // [MiiaFW] 認証必須フラグ
    }
  },
  {
    path: '/stream_viewer_p2',
    name: '',
    component: StreamViewerP2,
    meta: {
      onMenu: true, // [MiiaFW] メニュー表示用の拡張
      requiresAuth: false // [MiiaFW] 認証必須フラグ
    }
  },
  {
    path: '/stream_viewer_p3',
    name: 'ページ3',
    component: StreamViewerP3,
    meta: {
      onMenu: true, // [MiiaFW] メニュー表示用の拡張
      requiresAuth: false // [MiiaFW] 認証必須フラグ
    }
  },
  {
    path: '/k01_01',
    name: 'ページ3',
    component: K01_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  }, {
    path: '/k02_01',
    name: 'ページ3',
    component: K02_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k03_01',
    name: 'ページ3',
    component: K03_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k03_02',
    name: 'ページ3',
    component: K03_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k04_01',
    name: 'ページ3',
    component: K04_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k05_01',
    name: 'ページ3',
    component: K05_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k05_02',
    name: 'ページ3',
    component: K05_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k05_03',
    name: 'ページ3',
    component: K05_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k06_01',
    name: 'ページ3',
    component: K06_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k06_02',
    name: 'ページ3',
    component: K06_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k06_03',
    name: 'ページ3',
    component: K06_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k06_04',
    name: 'ページ3',
    component: K06_04,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k06_05',
    name: 'ページ3',
    component: K06_05,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k07_01',
    name: 'ページ3',
    component: K07_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k07_02',
    name: 'ページ3',
    component: K07_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k07_03',
    name: 'ページ3',
    component: K07_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k07_04',
    name: 'ページ3',
    component: K07_04,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k07_05',
    name: 'ページ3',
    component: K07_05,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k08_01',
    name: 'ページ3',
    component: K08_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k08_02',
    name: 'ページ3',
    component: K08_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k08_03',
    name: 'ページ3',
    component: K08_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k08_04',
    name: 'ページ3',
    component: K08_04,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/k08_05',
    name: 'ページ3',
    component: K08_05,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f01_01',
    name: 'ページ3',
    component: F01_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f01_02',
    name: 'ページ3',
    component: F01_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f01_03',
    name: 'ページ3',
    component: F01_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f01_04',
    name: 'ページ3',
    component: F01_04,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f01_05',
    name: 'ページ3',
    component: F01_05,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_01',
    name: 'ページ3',
    component: F02_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_02',
    name: 'ページ3',
    component: F02_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_03',
    name: 'ページ3',
    component: F02_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_04',
    name: 'ページ3',
    component: F02_04,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_05',
    name: 'ページ3',
    component: F02_05,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_06',
    name: 'ページ3',
    component: F02_06,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f02_07',
    name: 'ページ3',
    component: F02_07,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f03_01',
    name: 'ページ3',
    component: F03_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f03_02',
    name: 'ページ3',
    component: F03_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_01',
    name: 'ページ3',
    component: F04_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_02',
    name: 'ページ3',
    component: F04_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_03',
    name: 'ページ3',
    component: F04_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_04',
    name: 'ページ3',
    component: F04_04,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_05',
    name: 'ページ3',
    component: F04_05,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_06',
    name: 'ページ3',
    component: F04_06,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_07',
    name: 'ページ3',
    component: F04_07,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_08',
    name: 'ページ3',
    component: F04_08,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_09',
    name: 'ページ3',
    component: F04_09,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_10',
    name: 'ページ3',
    component: F04_10,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_11',
    name: 'ページ3',
    component: F04_11,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_12',
    name: 'ページ3',
    component: F04_12,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f04_13',
    name: 'ページ3',
    component: F04_13,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f05_01',
    name: 'ページ3',
    component: F05_01,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f05_02',
    name: 'ページ3',
    component: F05_02,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  },
  {
    path: '/f05_03',
    name: 'ページ3',
    component: F05_03,
    meta: {
      onMenu: true, // [MiiaFW]メニュー表示用の拡張
      requiresAuth: false // [MiiaFW]認証必須フラグ
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: /miiafw, // サブディレクトリを使用する場合に有効化する。併せてvue.config.jsの「baseUrl」も有効化する。
  routes
})

export default router
